/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useMemo, useRef, useState } from 'react'
import { ToastContainer } from 'react-toastify'
import { config, fetchData, toasterrormsg, toastsuccessmsg, useMenuIdPermissions } from '../../../../reusable'
import { PageTitle } from '../../../../_metronic/layout/core'
import Select from 'react-select'
import DataTable from 'react-data-table-component'
import moment from 'moment'
import { Tr } from '../../../../_metronic/i18n/Tr'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import JoditEditor from 'jodit-react'


const AdminCommission = () => {
  //overview states
  let t = Tr()
  const { menuIdEdit } = useMenuIdPermissions()

  const enPrecautionRef = useRef(null) as any
  const ruPrecautionRef = useRef(null) as any
  const uzPrecautionRef = useRef(null) as any

  const [error, setError] = useState(Object)
  const [listData, setListData] = useState([])
  const [currentCommissionData, setCurrentCommissionData] = useState([])
  const [serviceHours, setServiceHours] = useState('')
  const [totalRecords, setTotalRecords] = useState('') as any
  const [limit, setLimit] = useState(5)
  const [offset, setOffset] = useState(0)
  const [hours, setHours] = useState('')
  const [globalAccessNumber, setGlobalAccessNumber] = useState('')
  // coupon
  const [enCouponPrescription, setEnCouponPrescription] = useState('')
  const [ruCouponPrescription, setRuCouponPrescription] = useState('')
  const [uzCouponPrescription, setUzCouponPrescription] = useState('')
  const [commissionData, setCommissionData] = useState([
    { settingId: '', key: '', value: '', year: '', month: '', oldCommission: '' },
  ])

  const [insayrCommissionLoading, setInsayrCommissionLoading] = useState(false)
  const [autoRejectTimerLoading, setAutoRejectTimerLoading] = useState(false)
  const [globalAccessLoading, setGlobalAccessLoading] = useState(false)
  const [serviceHorsLoading, setServiceHorsLoading] = useState(false)
  const [couponPrecautionLoading, setCouponPrecautionLoading] = useState(false)

  // refer code states
  const [accommmodationReferralPrice, setAccommmodationReferralPrice] = useState("")
  const [spaceRentalsReferralPrice, setSpaceRentalsReferralPrice] = useState("")
  const [tourPackagesReferralPrice, setTourPackagesReferralPrice] = useState("")
  const [carRentalsReferralPrice, setCarRentalsReferralPrice] = useState("")
  const [cafeAndRestaurantsReferralPrice, setCafeAndRestaurantsReferralPrice] = useState("")
  const [referralTermsAndPolicy, setReferralTermsAndPolicy] = useState("")
  const [referralLoading, setReferralLoading] = useState(false)


  const currentYear = new Date().getFullYear()
  const yearList = Array.from({ length: 11 }, (_, i) => ({
    value: (currentYear + i).toString(),
    label: (currentYear + i).toString(),
  }))

  const [monthList] = useState([
    { value: '01', label: 'January' },
    { value: '02', label: 'February' },
    { value: '03', label: 'March' },
    { value: '04', label: 'April' },
    { value: '05', label: 'May' },
    { value: '06', label: 'June' },
    { value: '07', label: 'July' },
    { value: '08', label: 'August' },
    { value: '09', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' },
  ]) as any

  const commissionDetailApiCall = async () => {
    var response: any = await fetchData('admin/commissionSettingList', {})

    if (response.status == '200') {
      var data = response.data
      const trimData = (data: any[]) => {
        return data.map((item) => ({
          settingId: item.settingId !== '' ? item.settingId : '',
          key: item.key !== '' ? item.key : '',
          value: '',
          year: '',
          month: '',
          oldCommission: item.oldCommission,
          nextMonthDate: item.nextMonthDate,
        }))
      }

      const trimmedData = trimData(data)

      // Sort the data to ensure Accommodation Vendor Commission (7) appears first
      const sortedData = [...trimmedData].sort((a, b) => {
        if (a.settingId === '7') return -1 // Move Accommodation to the top
        if (b.settingId === '7') return 1
        return 0 // Keep others in their original order
      })

      setCommissionData(sortedData)
    } else {
      toasterrormsg(response.message)
    }
  }

  //   hotel list api call
  const commissionHistoryListApiCall = async () => {
    var param: any = {
      limit: limit,
      offset: offset,
    }

    var res = await fetchData('admin/commissionhistorylist', param)

    if (res.status == '200') {
      var data = res.data
      setTotalRecords(data.totalRecords)
      setListData(data.data)
    } else {
      toasterrormsg(res.message)
    }
  }

  const referralDataApiCall = async () => {
    var res = await fetchData('admin/viewreferralpriceandpolicy', {});

    if (res.status == '200') {

      res.data.forEach((item: any) => {
        switch (item.key) {
          case 'accommmodationReferralPrice':
            setAccommmodationReferralPrice(item.value);
            break;
          case 'spaceRentalsReferralPrice':
            setSpaceRentalsReferralPrice(item.value);
            break;
          case 'tourPackagesReferralPrice':
            setTourPackagesReferralPrice(item.value);
            break;
          case 'carRentalsReferralPrice':
            setCarRentalsReferralPrice(item.value);
            break;
          case "cafeAndRestaurantsReferralPrice":
            setCafeAndRestaurantsReferralPrice(item.value);
            break;
          case 'referralTermsAndPolicy':
            setReferralTermsAndPolicy(item.value);
            break;
          default:
            break;
        }
      });
    } else {
      toasterrormsg(res.message);
    }
  };


  const currentCommisionListApiCall = async () => {
    var param: any = {
      limit: limit,
      offset: offset,
    }

    var res = await fetchData('admin/latestCommision', param)

    if (res.status == '200') {
      var data = res.data

      setCurrentCommissionData(data)
    } else {
      toasterrormsg(res.message)
    }
  }
  const viewBookingRejectedHours = async () => {
    var param: any = {
      limit: limit,
      offset: offset,
    }

    var res = await fetchData('admin/bookingrejectedhourview', param)

    if (res.status == '200') {
      var data = res.data
      setHours(data.value)
    } else {
      toasterrormsg(res.message)
    }
  }
  const viewGlobalNumberAndServiceHoursApiCall = async () => {
    var res = await fetchData('admin/viewTimeAndPhoneGlobalSettings', {})

    if (res.status == '200') {
      var data = res.data
      setEnCouponPrescription(data.en_precaution);
      setRuCouponPrescription(data.ru_precaution);
      setUzCouponPrescription(data.uz_precaution);

      setGlobalAccessNumber(data.globalAccessNumber)

      setServiceHours(data.serviceHours)
    } else {
      toasterrormsg(res.message)
    }
  }

  useEffect(() => {
    commissionDetailApiCall()
    viewBookingRejectedHours()
    currentCommisionListApiCall()
    viewGlobalNumberAndServiceHoursApiCall()
    referralDataApiCall()
  }, [])

  useEffect(() => {
    commissionHistoryListApiCall()
  }, [limit, offset])

  const removeError = (index: number, field: any) => {
    setError((prevError: any) => {
      const newError = { ...prevError }
      delete newError[`${field}${index}`]
      return newError
    })
  }

  const removeError2 = (err: any) => {
    // Ensure error is an array before spreading
    var tmp = Array.isArray(error) ? [...error] : [{}]

    // Ensure the first object exists
    if (!tmp[0]) tmp[0] = {}

    tmp[0][err] = '' // Clear the specific error key
    setError(tmp)
  }

  const cancelHoursValidate = () => {
    var isValid = true

    var errorTmp = Array.isArray(error) ? [...error] : [{}] // Ensure it's an array
    if (hours == '') {
      errorTmp[0].hours = t('Rejection Hour Is Required')
      isValid = false
    } else if (hours < '1') {
      errorTmp[0].hours = t('Rejection Hour Is Not Valid')
      isValid = false
    }

    setError(errorTmp)

    if (isValid) {
      saveHours()
    }
  }

  const globalAccessValidate = () => {
    var isValid = true

    var errorTmp = Array.isArray(error) ? [...error] : [{}] // Ensure it's an array
    if (globalAccessNumber == '') {
      errorTmp[0].globalAccessNumber = t('Global Access Number Is Required')
      isValid = false
    } else if (globalAccessNumber.length > 15) {
      errorTmp[0].globalAccessNumber = t('Gllobal Access Number Is Not Valid')
      isValid = false
    }
    setError(errorTmp)

    if (isValid) {
      saveGlobalAccessHours()
    }
  }
  const serviceHourValidate = () => {
    let err = 0
    var errorTmp = Array.isArray(error) ? [...error] : [{}] // Ensure it's an array

    // Check if the row has any filled value
    if (serviceHours == '') {
      errorTmp[0].serviceHours = t('Service Hours Are Required')
      err = 1
    }

    setError(errorTmp)
    if (err === 0) {
      saveServiceHours()
    }
  }

  const couponPrescriptionValidation = () => {
    let err = 0
    var errorTmp = Array.isArray(error) ? [...error] : [{}] // Ensure it's an array

    // Check if the row has any filled value
    if (enCouponPrescription == '' || enCouponPrescription == null || enCouponPrescription == undefined) {
      errorTmp[0].enCouponPrescription = t('English Coupon Description Is Required')
      err = 1
    }
    if (ruCouponPrescription == '' || ruCouponPrescription == null || ruCouponPrescription == undefined) {
      errorTmp[0].ruCouponPrescription = t('Russian Coupon Description Is Required')
      err = 1
    }
    if (uzCouponPrescription == '' || uzCouponPrescription == null || uzCouponPrescription == undefined) {
      errorTmp[0].uzCouponPrescription = t('Uzbek Coupon Description Is Required')
      err = 1
    }

    setError(errorTmp)
    if (err === 0) {
      saveCouponPrescription()
    }
  }

  //
  const saveHours = async () => {
    setAutoRejectTimerLoading(true)
    const param = {
      hours: hours,
    }
    var res = await fetchData('admin/bookingrejectedhourchange', param)

    if (res.status == '200') {
      setAutoRejectTimerLoading(false)
      toastsuccessmsg(res.message)
    } else {
      setAutoRejectTimerLoading(false)
      toasterrormsg(res.message)
    }
  }

  //
  const saveGlobalAccessHours = async () => {
    setGlobalAccessLoading(true)
    const param = {
      globalAccessNumber: globalAccessNumber,
    }
    var res = await fetchData('admin/timeAndPhoneGlobalSettings', param)

    if (res.status == '200') {
      toastsuccessmsg(res.message)
      viewGlobalNumberAndServiceHoursApiCall()
      setGlobalAccessLoading(false)
    } else {
      toasterrormsg(res.message)
      setGlobalAccessLoading(false)
    }
  }

  //
  const saveServiceHours = async () => {
    setServiceHorsLoading(true)
    const param = {
      serviceHours: serviceHours,
    }
    var res = await fetchData('admin/timeAndPhoneGlobalSettings', param)

    if (res.status == '200') {
      toastsuccessmsg(res.message)
      viewGlobalNumberAndServiceHoursApiCall()
      setServiceHorsLoading(false)
    } else {
      toasterrormsg(res.message)
      setServiceHorsLoading(false)
    }
  }

  //
  const saveCouponPrescription = async () => {
    setCouponPrecautionLoading(true)
    const param = {
      en_precaution: enCouponPrescription,
      ru_precaution: ruCouponPrescription,
      uz_precaution: uzCouponPrescription,
    }
    var res = await fetchData('admin/timeAndPhoneGlobalSettings', param)

    if (res.status == '200') {
      toastsuccessmsg(res.message)
      viewGlobalNumberAndServiceHoursApiCall()
      setCouponPrecautionLoading(false)
    } else {
      toasterrormsg(res.message)
      setCouponPrecautionLoading(false)
    }
  }



  const commissionValidate = () => {
    const errotmp: any = {}
    let err = 0

    const currentDate = new Date()
    const currentMonth = currentDate.getMonth() + 1 // getMonth() is 0-based
    const currentYear = currentDate.getFullYear()

    commissionData.forEach((commissionSlot: any, index: number) => {
      const selectedMonth = commissionSlot.month ? parseInt(commissionSlot.month) : null
      const selectedYear = commissionSlot.year ? parseInt(commissionSlot.year) : null

      // Check if the row has any filled value
      if (commissionSlot.value) {
        // Validate required fields
        if (!selectedMonth) {
          errotmp[`month${index}`] = t('Month Is required')
          err = 1
        }

        if (!selectedYear) {
          errotmp[`year${index}`] = t('Year Is required')
          err = 1
        }

        if (selectedYear && selectedYear < currentYear) {
          errotmp[`year${index}`] = t("Year can't be Smaller than the current Year")
          err = 1
        }

        if (selectedMonth && selectedMonth < currentMonth) {
          errotmp[`month${index}`] = t("Month can't be Smaller than the current month")
          err = 1
        } else if (selectedMonth && selectedYear == currentYear && selectedMonth == currentMonth) {
          errotmp[`month${index}`] = t("Month can't be Equal To current month")
          err = 1
        }
      }
    })

    setError(errotmp)
    if (err === 0) {
      saveCommission()
    }
  }

  //
  const referralValidate = () => {
    let err = 0
    var errorTmp = Array.isArray(error) ? [...error] : [{}] // Ensure it's an array

    // ✅ Accommodation Referral Price
    if (!accommmodationReferralPrice || isNaN(Number(accommmodationReferralPrice)) || Number(accommmodationReferralPrice) <= 0) {
      errorTmp[0].accommmodationReferralPrice = t('Accommodation Price is required and must be greater than 0')
      err = 1
    } else if (accommmodationReferralPrice.toString().length > 10) {
      errorTmp[0].accommmodationReferralPrice = t('Accommodation Price must not exceed 10 characters')
      err = 1
    }

    // ✅ Space Rentals Referral Price
    if (!spaceRentalsReferralPrice || isNaN(Number(spaceRentalsReferralPrice)) || Number(spaceRentalsReferralPrice) <= 0) {
      errorTmp[0].spaceRentalsReferralPrice = t('Space Rentals Price is required and must be greater than 0')
      err = 1
    } else if (spaceRentalsReferralPrice.toString().length > 10) {
      errorTmp[0].spaceRentalsReferralPrice = t('Space Rentals Price must not exceed 10 characters')
      err = 1
    }

    // ✅ Tour Packages Referral Price
    if (!tourPackagesReferralPrice || isNaN(Number(tourPackagesReferralPrice)) || Number(tourPackagesReferralPrice) <= 0) {
      errorTmp[0].tourPackagesReferralPrice = t('Tour Packages Price is required and must be greater than 0')
      err = 1
    } else if (tourPackagesReferralPrice.toString().length > 10) {
      errorTmp[0].tourPackagesReferralPrice = t('Tour Packages Price must not exceed 10 characters')
      err = 1
    }

    // ✅ Car Rentals Referral Price
    if (!carRentalsReferralPrice || isNaN(Number(carRentalsReferralPrice)) || Number(carRentalsReferralPrice) <= 0) {
      errorTmp[0].carRentalsReferralPrice = t('Car Rentals Price is required and must be greater than 0')
      err = 1
    } else if (carRentalsReferralPrice.toString().length > 10) {
      errorTmp[0].carRentalsReferralPrice = t('Car Rentals Price must not exceed 10 characters')
      err = 1
    }

    // ✅ Café & Restaurants Referral Price
    if (!cafeAndRestaurantsReferralPrice || isNaN(Number(cafeAndRestaurantsReferralPrice)) || Number(cafeAndRestaurantsReferralPrice) <= 0) {
      errorTmp[0].cafeAndRestaurantsReferralPrice = t('Cafe Restaurant Price is required and must be greater than 0')
      err = 1
    } else if (cafeAndRestaurantsReferralPrice.toString().length > 10) {
      errorTmp[0].cafeAndRestaurantsReferralPrice = t('Cafe Restaurant Price must not exceed 10 characters')
      err = 1
    }

    // ✅ Referral Terms & Policy (Text Editor)
    if (!referralTermsAndPolicy || referralTermsAndPolicy.trim() === '') {
      errorTmp[0].referralTermsAndPolicy = t('Referral Terms & Policy is required')
      err = 1
    }

    setError(errorTmp)

    // If no errors → save
    if (err === 0) {
      saveReferral()
    }
  }


  const saveReferral = async () => {
    setReferralLoading(true)
    const param = {
      accommmodationReferralPrice: accommmodationReferralPrice,
      spaceRentalsReferralPrice: spaceRentalsReferralPrice,
      tourPackagesReferralPrice: tourPackagesReferralPrice,
      carRentalsReferralPrice: carRentalsReferralPrice,
      cafeAndRestaurantsReferralPrice: cafeAndRestaurantsReferralPrice,
      referralTermsAndPolicy: referralTermsAndPolicy
    }
    var res = await fetchData('admin/savereferralpriceandpolicy', param)

    if (res.status == '200') {
      toastsuccessmsg(res.message)
      viewGlobalNumberAndServiceHoursApiCall()
      setReferralLoading(false)
    } else {
      toasterrormsg(res.message)
      setReferralLoading(false)
    }
  }

  const saveCommission = async () => {
    var tmp2 = sessionStorage.getItem('admin')
    // Step 2: Check if the item is not null
    if (tmp2) {
      // Step 3: Parse the JSON string
      var adminData = JSON.parse(tmp2)
      // Step 4: Access the adminId
      var adminId = adminData.adminId
    }

    const allEmpty = commissionData.every(
      (item) =>
        item.value.trim() === '' || item.value.trim() == null || item.value.trim() == undefined
    )

    if (allEmpty) {
      toasterrormsg('Please Fill Atleast One Value Before Submitting.')
      return
    }

    setInsayrCommissionLoading(true)


    for (const item of commissionData) {
      if (item.value != '' && item.value != undefined && item.value != null) {
        const param = {
          settingId: item.settingId,
          value: Number(item.value),
          adminId: adminId,
          year: item.year,
          month: item.month,
        }
        var res = await fetchData('admin/editcommissionsetting', param)
      }
    }

    if (res.status == '200') {
      toastsuccessmsg('Updated Successfully')
      setInsayrCommissionLoading(false)

      commissionDetailApiCall()
      commissionHistoryListApiCall()
    } else {
      setInsayrCommissionLoading(false)

      toasterrormsg(res.message)
    }
  }

  const handleacccommodationchange = (index: number, field: any, value: any) => {
    if (field == 'value' && !/^\d*\.?\d*$/.test(value)) {
      return // Exit early if the value is not numeric or a decimal
    } else if (field == 'value' && value > 100) {
      return
    } else if (field == 'value' && value < 1 && value > 0.99) {
      return
    } else {
      var accomodationslots: any = [...commissionData]
      accomodationslots[index][field] = value
      setCommissionData(accomodationslots)
    }
  }

  useEffect(() => {
    document.title = 'Insayr | Settings'
  }, [])

  const column = useMemo(
    () => [
      {
        name: t('Vendor Type'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-6 d-flex align-items-center justify-content-center cursor-pointer'>
              <label className='cursor-pointer'>
                {row.categoryId == '1'
                  ? t('Accommodation Vendor')
                  : row.categoryId == '4'
                    ? t('Space Vendor')
                    : row.categoryId == '5'
                      ? t('Tour Vendor')
                      : row.categoryId == '7'
                        ? t('Car Vendor')
                        : ''}
              </label>
            </div>
          </div>
        ),
        sortable: false,
        filter: true,
        width: '200px',
      },
      {
        name: t('Current Fee'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.oldCommission != '' &&
                row.oldCommission != null &&
                row.oldCommission != undefined
                ? row.oldCommission + ' %'
                : '0%'}
            </div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => Number(row.oldCommission),
      },
      {
        name: t('New Fee(%)'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              <div className='fw-bold fs-5'>
                {row.commission != '' && row.commission != null && row.commission != undefined
                  ? row.commission + ' %'
                  : '0%'}
              </div>
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.commission),
        filter: true,
      },
      {
        name: t('Effective From'),
        cell: (row: any) => {
          const monthObj = monthList.find((m: any) => m.value === row.month)
          const monthName = monthObj ? monthObj.label : row.month
          return (
            <div className='my-3'>
              <div className='fw-bold fs-5'>
                {monthName} {row.year}
              </div>
            </div>
          )
        },
        sortable: true,
        selector: (row: any) => row.month,
        filter: true,
      },
      {
        name: t('Changed By'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-6 d-flex align-items-center justify-content-center cursor-pointer'>
              <label className='cursor-pointer'>{row.createdBy != '' ? row.createdBy : ''}</label>
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => row.month,
        filter: true,
      },
      {
        name: t('Change Date & Time'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-6 d-flex align-items-center justify-content-center cursor-pointer'>
              <label className='cursor-pointer'>
                {row.created ? moment(row.created).format('YYYY-MM-DD HH:mm:ss') : ''}
              </label>
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => row.month,
        filter: true,
      },
    ],
    [t]
  )

  const column2 = useMemo(
    () => [
      {
        name: t('Vendor Type'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-6 d-flex align-items-center justify-content-center cursor-pointer'>
              <label className='cursor-pointer'>
                {row.categoryId == '1'
                  ? t('Accommodation Vendor')
                  : row.categoryId == '4'
                    ? t('Space Vendor')
                    : row.categoryId == '5'
                      ? t('Tour Vendor')
                      : row.categoryId == '7'
                        ? t('Car Vendor')
                        : ''}
              </label>
            </div>
          </div>
        ),
        sortable: false,
        filter: true,
        width: '200px',
      },
      {
        name: t('Current Fee'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.oldCommission != '' &&
                row.oldCommission != null &&
                row.oldCommission != undefined
                ? row.oldCommission + ' %'
                : '0%'}
            </div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => Number(row.oldCommission),
      },
      {
        name: t('New Fee(%)'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              <div className='fw-bold fs-5'>
                {row.commission != '' && row.commission != null && row.commission != undefined
                  ? row.commission + ' %'
                  : '0%'}
              </div>
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.commission),
        filter: true,
      },
      {
        name: t('Effective From'),
        cell: (row: any) => {
          const monthObj = monthList.find((m: any) => m.value === row.month)
          const monthName = monthObj ? monthObj.label : row.month
          return (
            <div className='my-3'>
              <div className='fw-bold fs-5'>
                {monthName} {row.year}
              </div>
            </div>
          )
        },
        sortable: true,
        selector: (row: any) => row.month,
        filter: true,
      },
    ],
    [t]
  )
  const handlePageChange = (newPage: number) => {
    const totalPages = Math.ceil(totalRecords / limit)

    if (newPage === 1) {
      setOffset(0)
    } else if (newPage === totalPages) {
      setOffset((totalPages - 1) * limit)
    } else {
      setOffset((newPage - 1) * limit)
    }
  }

  const handleRowsPerPageChange = (newRowsPerPage: number, currentPage: number) => {
    setLimit(newRowsPerPage)
  }

  return (
    <>
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>{t('View Settings')}</PageTitle>

      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>
              {t('Add')} {t('Insayr Commission Fees')}
            </h3>
          </div>
        </div>
        <div className='col-lg-12  mx-4 my-3'>
          <span className='fw-bolder fs-5 form-label'>
            {t('*Note:')}{' '}
            <span className='fs-7 form-label'>{t('You Can Update Any Of The Commission')}</span>
          </span>
        </div>
        <div className='card-body p-9'>
          {commissionData.map((items: any, index: any) => (
            <>
              <div className='row mb-7'>
                <div className='col-lg-4'>
                  <label className='fw-bold text-muted'>{items.key}</label>
                  <div className='d-flex align-items-center gap-3'>
                    <input
                      type='text'
                      placeholder='Enter Commision'
                      className='form-control form-control-solid w-100'
                      value={items.value}
                      onChange={(event: any) => {
                        handleacccommodationchange(index, 'value', event.target.value)
                        removeError(index, 'value')
                      }}
                    />
                    {/* Percentage Label */}
                    <span className='fw-bolder fs-6 text-dark'>%</span>
                  </div>{' '}
                  <label className='text-danger'>{error[`value${index}`] || ''}</label>
                </div>
                <div className='col-lg-3'>
                  <label className='fw-bold text-muted'>{t('Effective Month')}</label>
                  <div className='d-flex align-items-center gap-3'>
                    <Select
                      name='selectMonth'
                      id='selectMonth'
                      placeholder={t('Select Month')}
                      isSearchable={true}
                      options={monthList}
                      value={monthList.find((option: any) => option.value === items.month) || null}
                      onChange={(event: any) => {
                        handleacccommodationchange(index, 'month', event.value)
                        removeError(index, 'month')
                      }}
                      styles={{
                        container: (provided) => ({ ...provided, width: '100%' }),
                        control: (provided) => ({ ...provided, minHeight: 43 }),
                      }}
                    />
                  </div>{' '}
                  <label className='text-danger'>{error[`month${index}`] || ''}</label>
                </div>
                <div className='col-lg-3'>
                  <label className='fw-bold text-muted'>{t('Effective Year')}</label>
                  <div className='d-flex align-items-center gap-3'>
                    <Select
                      name={`selectYear${index}`}
                      id={`selectYear${index}`}
                      placeholder={t('Select Year')}
                      isSearchable={true}
                      options={yearList}
                      value={yearList.find((option: any) => option.value == items.year) || null}
                      onChange={(event: any) => {
                        handleacccommodationchange(index, 'year', event.value)
                        removeError(index, 'year')
                      }}
                      styles={{
                        container: (provided) => ({ ...provided, width: '100%' }),
                        control: (provided) => ({ ...provided, minHeight: 43 }),
                      }}
                    />
                  </div>{' '}
                  <label className='text-danger'>{error[`year${index}`] || ''}</label>
                </div>
              </div>
            </>
          ))}
          {menuIdEdit ? (
            <button
              disabled={insayrCommissionLoading}

              className='btn btn-success'
              onClick={() => {
                commissionValidate()
              }}
            >

              {!insayrCommissionLoading && t('Save')}

              {insayrCommissionLoading && (
                <span className='indicator-progress' style={{ display: 'block' }}>
                  {t('Please wait...')}{' '}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          ) : (
            ''
          )}
        </div>
      </div>

      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>{t('Active Commission Rates')}</h3>
          </div>
        </div>

        <DataTable
          columns={column2}
          data={currentCommissionData}
          pagination
          paginationServer={true}
          onChangePage={handlePageChange}
          paginationPerPage={5}
          onChangeRowsPerPage={handleRowsPerPageChange}
          paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
          subHeader={true}
          paginationComponentOptions={{
            rowsPerPageText: t('Rows Per Page'),
          }}
        />
      </div>

      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>{t('Commission Changes History')}</h3>
          </div>
        </div>

        <DataTable
          columns={column}
          data={listData}
          pagination
          paginationServer={true}
          onChangePage={handlePageChange}
          paginationTotalRows={totalRecords}
          paginationPerPage={5}
          onChangeRowsPerPage={handleRowsPerPageChange}
          paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
          subHeader={true}
          paginationComponentOptions={{
            rowsPerPageText: t('Rows Per Page'),
          }}
        />
      </div>

      <div className='row justify-content-between'>
        <div className='col-lg-6 col-md-12 mb-4'>
          <div className='card p-5 h-100'>
            <div className='card-header'>
              <div className='card-title m-0'>
                <h3 className='fw-bolder m-0'>{t('Bookings Auto-Rejection Timer')}</h3>
              </div>
            </div>

            <div className='card-body p-9'>
              <div className='col-lg-12'>
                <label className='fw-bold text-muted'>
                  {t('Set Auto-Rejection Time for Pending Bookings')}
                </label>
                <div className='mt-5 mb-5'>
                  <input
                    type='text'
                    placeholder={t('Add hours limit')}
                    className='form-control form-control-solid w-100'
                    value={hours}
                    onChange={(event: any) => {
                      setHours(event.target.value)
                      removeError2('hours')
                    }}
                  />

                  <label className='text-danger'>{error.length > 0 ? error[0].hours : ''}</label>
                </div>{' '}
              </div>
              {menuIdEdit ? (
                <button
                  disabled={autoRejectTimerLoading}
                  className='btn btn-success'
                  onClick={() => {
                    cancelHoursValidate()
                  }}
                >



                  {!autoRejectTimerLoading && t('Save')}

                  {autoRejectTimerLoading && (
                    <span className='indicator-progress' style={{ display: 'block' }}>
                      {t('Please wait...')}{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>

        <div className='col-lg-6 col-md-12 mb-4'>
          <div className='card p-5 h-100'>
            <div className='card-header'>
              <div className='card-title m-0'>
                <h3 className='fw-bolder m-0'>{t('Global Access Number')}</h3>
              </div>
            </div>

            <div className='card-body p-9'>
              <div className='col-lg-12'>
                <label className='fw-bold text-muted'>{t('Set Global Access Number')}</label>
                <div className='mt-5 mb-5'>
                  <PhoneInput
                    country={'in'}
                    inputProps={{
                      name: 'mobileNumber',
                      id: 'mobileNumber',
                      autoComplete: 'off',
                      className: `form-control  w-100 py-6`,
                      placeholder: 'Enter Mobile Number',
                    }}
                    dropdownClass={`dropdown-menuphone `}
                    value={globalAccessNumber}
                    onChange={(value) => setGlobalAccessNumber(value)}
                  />

                  <label className='text-danger'>
                    {error.length > 0 ? error[0].globalAccessNumber : ''}
                  </label>
                </div>{' '}
              </div>
              {menuIdEdit ? (
                <button
                  disabled={globalAccessLoading}
                  className='btn btn-success'
                  onClick={() => {
                    globalAccessValidate()
                  }}
                >

                  {!globalAccessLoading && t('Save')}

                  {globalAccessLoading && (
                    <span className='indicator-progress' style={{ display: 'block' }}>
                      {t('Please wait...')}{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      </div>
      <div className='row justify-content-center' >
        <div className='col-lg-12 col-md-12 mb-4'>
          <div className='card p-5 h-100'>
            <div className='card-header'>
              <div className='card-title m-0'>
                <h3 className='fw-bolder m-0'>{t('Referral Pricing')}</h3>
              </div>
            </div>

            <div className='card-body p-9 row '>
              <>
                <div className='col-lg-5'>

                  <div className='col-lg-12 col-md-12 col-sm-12' >
                    <label className='fw-bold text-muted'>{t('Accommodation Referral Price')}</label>
                    <div className='d-flex align-items-center'>
                      <input
                        type='text'
                        placeholder='Enter Price'
                        className='form-control form-control-solid w-100'
                        value={accommmodationReferralPrice}
                        onChange={(event: any) => {
                          setAccommmodationReferralPrice(event.target.value)
                          removeError2('accommmodationReferralPrice')
                        }}
                      />
                    </div>{' '}
                    <label className='text-danger'>
                      {error && error[0] && error[0].accommmodationReferralPrice ? error[0].accommmodationReferralPrice : ''}
                    </label>
                  </div>
                  <div className='col-lg-12 col-md-12 col-sm-12' >
                    <label className='fw-bold text-muted'>{t('Space Rental Referral Price')}</label>
                    <div className='d-flex align-items-center'>
                      <input
                        type='text'
                        placeholder='Enter Price'
                        className='form-control form-control-solid w-100'
                        value={spaceRentalsReferralPrice}
                        onChange={(event: any) => {
                          setSpaceRentalsReferralPrice(event.target.value)
                          removeError2('spaceRentalsReferralPrice')
                        }}
                      />
                    </div>{' '}
                    <label className='text-danger'>
                      {error && error[0] && error[0].spaceRentalsReferralPrice ? error[0].accommmodationReferralPrice : ''}
                    </label>
                  </div>

                  <div className='col-lg-12 col-md-12 col-sm-12' >

                    <label className='fw-bold text-muted'>{t('Tour Package Referral Price')}</label>
                    <div className='d-flex align-items-center'>
                      <input
                        type='text'
                        placeholder='Enter Price'
                        className='form-control form-control-solid w-100'
                        value={tourPackagesReferralPrice}
                        onChange={(event: any) => {
                          setTourPackagesReferralPrice(event.target.value)
                          removeError2('tourPackagesReferralPrice')
                        }}
                      />
                    </div>{' '}
                    <label className='text-danger'>
                      {error && error[0] && error[0].tourPackagesReferralPrice ? error[0].tourPackagesReferralPrice : ''}
                    </label>
                  </div>
                  <div className='col-lg-12 col-md-12 col-sm-12' >
                    <label className='fw-bold text-muted'>{t('Car Rental Referral Price')}</label>
                    <div className='d-flex align-items-center'>
                      <input
                        type='text'
                        placeholder='Enter Price'
                        className='form-control form-control-solid w-100'
                        value={carRentalsReferralPrice}
                        onChange={(event: any) => {
                          setCarRentalsReferralPrice(event.target.value)
                          removeError2('carRentalsReferralPrice')
                        }}
                      />
                    </div>{' '}
                    <label className='text-danger'>
                      {error && error[0] && error[0].carRentalsReferralPrice ? error[0].carRentalsReferralPrice : ''}
                    </label>
                  </div>
                  <div className='col-lg-12 col-md-12 col-sm-12' >
                    <label className='fw-bold text-muted'>{t('Cafe & Restaurant Referral Price')}</label>
                    <div className='d-flex align-items-center'>
                      <input
                        type='text'
                        placeholder='Enter Price'
                        className='form-control form-control-solid w-100'
                        value={cafeAndRestaurantsReferralPrice}
                        onChange={(event: any) => {
                          setCafeAndRestaurantsReferralPrice(event.target.value)
                          removeError2('cafeAndRestaurantsReferralPrice')
                        }}
                      />
                    </div>{' '}
                    <label className='text-danger'>
                      {error && error[0] && error[0].cafeAndRestaurantsReferralPrice ? error[0].cafeAndRestaurantsReferralPrice : ''}
                    </label>
                  </div>

                </div>
                <div className='col-lg-7'>

                  <div className='col-lg-12 col-md-12 col-sm-12' >
                    <label className='fw-bold text-muted'>{t('Referral Terms & Policy')}</label>
                    <div className='d-flex align-items-center'>
                      <JoditEditor
                        ref={enPrecautionRef}
                        config={config(400)}   // ✅ pass custom height
                        className='form-control form-control-solid w-100'
                        value={referralTermsAndPolicy}

                        onBlur={(newContent: any) => {
                          setReferralTermsAndPolicy(newContent)
                          removeError2('referralTermsAndPolicy')
                        }}
                      />

                    </div>{' '}
                    <label className='text-danger'>
                      {error && error[0] && error[0].referralTermsAndPolicy ? error[0].accommmodationReferralPrice : ''}
                    </label>
                  </div>
                </div>
              </>

              {menuIdEdit ? (
                <div className="d-flex justify-content-start mt-4">
                  <button
                    className="btn btn-success"
                    disabled={referralLoading}
                    onClick={() => {
                      referralValidate()
                    }}
                  >
                    {!referralLoading && t('Save')}
                    {referralLoading && (
                      <span className="indicator-progress d-flex align-items-center">
                        {t('Please wait...')}
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    )}
                  </button>
                </div>
              ) : (
                ''
              )}
            </div>

          </div>

        </div>
      </div>

      <div className='card mb-5 mb-xl-10 col-lg-12' id='kt_profile_details_view'>
        <div className='card-header'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>{t('Coupon Precautions')}</h3>
          </div>
        </div>

        <div className='card-body py-0 pb-10'>
          <>
            <div className='row' >
              <div className='col-lg-6 mt-6'>
                <label className='fw-bold text-muted'>{t('English Coupon Prescription')}</label>
                <div className='d-flex align-items-center'>

                  <JoditEditor
                    ref={enPrecautionRef}
                    config={config(300)}   // ✅ pass custom height
                    value={enCouponPrescription}
                    onBlur={newContent => {
                      setEnCouponPrescription(newContent)
                      removeError2('enCouponPrescription')
                    }} />
                </div>{' '}
                <label className='text-danger'>
                  {error && error[0] && error[0].enCouponPrescription ? error[0].enCouponPrescription : ''}
                </label>
              </div>
              <div className='col-lg-6 mt-6'>
                <label className='fw-bold text-muted'>{t('Russian Coupon Prescription')}</label>
                <div className='d-flex align-items-center'>
                  <JoditEditor
                    ref={ruPrecautionRef}
                    config={config(300)}   // ✅ pass custom height
                    value={ruCouponPrescription}
                    onBlur={newContent => {
                      setRuCouponPrescription(newContent)
                      removeError2('ruCouponPrescription')
                    }} />
                </div>{' '}
                <label className='text-danger'>
                  {error && error[0] && error[0].ruCouponPrescription ? error[0].ruCouponPrescription : ''}
                </label>
              </div>
              <div className='col-lg-6 mt-6'>
                <label className='fw-bold text-muted'>{t('Uzbek Coupon Prescription')}</label>
                <div className='d-flex align-items-center'>
                  <JoditEditor
                    ref={uzPrecautionRef}
                    config={config(300)}   // ✅ pass custom height
                    value={uzCouponPrescription}
                    onBlur={newContent => {
                      setUzCouponPrescription(newContent)
                      removeError2('uzCouponPrescription')
                    }} />
                </div>{' '}
                <label className='text-danger'>
                  {error && error[0] && error[0].uzCouponPrescription ? error[0].uzCouponPrescription : ''}
                </label>
              </div>
            </div>
          </>

          {menuIdEdit ? (
            <button
              className='btn btn-success'
              disabled={couponPrecautionLoading}
              onClick={() => {
                couponPrescriptionValidation()
              }}
            >

              {!couponPrecautionLoading && t('Save')}

              {couponPrecautionLoading && (
                <span className='indicator-progress' style={{ display: 'block' }}>
                  {t('Please wait...')}{' '}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          ) : (
            ''
          )}
        </div>
      </div>
      <div className='row justify-content-start' >
        <div className='col-lg-6 col-md-12 mb-4'>
          <div className='card  h-100'>
            <div className='card-header'>
              <div className='card-title m-0'>
                <h3 className='fw-bolder m-0'>{t('Service Hours')}</h3>
              </div>
            </div>

            <div className='card-body p-9 '>
              <>
                <div className='col-lg-12'>
                  <label className='fw-bold text-muted'>{t('Set Service Hours')}</label>
                  <div className='d-flex align-items-center'>
                    <textarea
                      placeholder='Enter Hours'
                      rows={10}
                      className='form-control form-control-solid w-100'
                      value={serviceHours}
                      onChange={(event: any) => {
                        setServiceHours(event.target.value)
                        removeError2('serviceHours')
                      }}
                    ></textarea>
                  </div>{' '}
                  <label className='text-danger'>
                    {error && error[0] && error[0].serviceHours ? error[0].serviceHours : ''}
                  </label>
                </div>
              </>

              {menuIdEdit ? (
                <button
                  className='btn btn-success'
                  disabled={serviceHorsLoading}
                  onClick={() => {
                    serviceHourValidate()
                  }}
                >

                  {!serviceHorsLoading && t('Save')}

                  {serviceHorsLoading && (
                    <span className='indicator-progress' style={{ display: 'block' }}>
                      {t('Please wait...')}{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      </div>


    </>
  )
}

export { AdminCommission }
